import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const ExpenseApi = createApi({
    reducerPath: "ExpenseApi",
    baseQuery: fetchBaseQuery({
        baseUrl: import.meta.env.VITE_API_URL + "/expenses",
        credentials: 'include',
        prepareHeaders: (headers) => {
            const token = localStorage.getItem('_at') || null;
            if (token) headers.set("Authorization", "Bearer " + token);
            return headers;
        }
    }),
    tagTypes: ['Expense', 'Balance'],
    endpoints: (builder) => ({

        listExpenses: builder.query({
            query: ({ page = 1, limit = 20, category = '', type = '', from = '', to = '', search = '' } = {}) => {
                const params = new URLSearchParams({ page, limit });
                if (category) params.append('category', category);
                if (type) params.append('type', type);
                if (from) params.append('from', from);
                if (to) params.append('to', to);
                if (search) params.append('search', search);
                return `?${params.toString()}`;
            },
            providesTags: ['Expense']
        }),

        expenseSummary: builder.query({
            query: ({ from = '', to = '' } = {}) => {
                const params = new URLSearchParams();
                if (from) params.append('from', from);
                if (to) params.append('to', to);
                const qs = params.toString();
                return `/summary${qs ? `?${qs}` : ''}`;
            },
            providesTags: ['Expense']
        }),

        topExpenseCategory: builder.query({
            query: ({ from = '', to = '' } = {}) => {
                const params = new URLSearchParams();
                if (from) params.append('from', from);
                if (to) params.append('to', to);
                const qs = params.toString();
                return `/top${qs ? `?${qs}` : ''}`;
            },
            providesTags: ['Expense']
        }),

        /** Full financial overview — cash balance, revenue, expenditure by type */
        financialOverview: builder.query({
            query: ({ from = '', to = '' } = {}) => {
                const params = new URLSearchParams();
                if (from) params.append('from', from);
                if (to) params.append('to', to);
                const qs = params.toString();
                return `/overview${qs ? `?${qs}` : ''}`;
            },
            providesTags: ['Expense', 'Balance']
        }),

        /** Opening balance */
        getOpeningBalance: builder.query({
            query: () => '/balance',
            providesTags: ['Balance']
        }),

        setOpeningBalance: builder.mutation({
            query: (body) => ({ url: '/balance', method: 'POST', body }),
            invalidatesTags: ['Balance', 'Expense']
        }),

        expenseDetail: builder.query({
            query: (id) => `/${id}`,
            providesTags: ['Expense']
        }),

        createExpense: builder.mutation({
            query: (body) => ({ url: '/', method: 'POST', body }),
            invalidatesTags: ['Expense']
        }),

        updateExpense: builder.mutation({
            query: ({ id, ...body }) => ({ url: `/${id}`, method: 'PUT', body }),
            invalidatesTags: ['Expense']
        }),

        deleteExpense: builder.mutation({
            query: (id) => ({ url: `/${id}`, method: 'DELETE' }),
            invalidatesTags: ['Expense']
        })
    })
});

export const {
    useListExpensesQuery,
    useExpenseSummaryQuery,
    useTopExpenseCategoryQuery,
    useFinancialOverviewQuery,
    useGetOpeningBalanceQuery,
    useSetOpeningBalanceMutation,
    useExpenseDetailQuery,
    useCreateExpenseMutation,
    useUpdateExpenseMutation,
    useDeleteExpenseMutation
} = ExpenseApi;
